import { useAppSelector } from "../store/storeHooks"
import { selectEffectiveCompanyId } from "../context/contextSelectors"

export function useSupplier() {
    const supplierId = useAppSelector(selectEffectiveCompanyId)

    if (!supplierId) {
        throw new Error("Invalid state: effective supplier id not found")
    }

    return {
        supplierId,
    }
}
